import React from 'react';
import ReactDOM from 'react-dom';
import Game from 'components/Game';

ReactDOM.render(
  <Game
    boardSize={6}
  />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/js/app.js